<ng-select [items]="companies$ | async" [loading]="isLoading" bindLabel="province"
  placeholder="{{'All' | translate}}" [typeToSearchText]="'Enter a company name' | translate" [typeahead]="searchKeyword$"
  [(ngModel)]="province" [editableSearchTerm]="true" appendTo="body" (change)="onChange($event)" [virtualScroll]="true">
  <ng-template ng-header-tmp>
    <small class="form-text text-muted">Loaded {{provinces.length}} of {{pagination.collectionSize}}</small>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    {{item.province}}
  </ng-template>
</ng-select>